import { createAxiosServiceInstance } from '../api';
import moment from 'moment';
import { apiConfig } from '../apiConfig';

const axios = createAxiosServiceInstance();
const baseUrl = `${apiConfig.serviceApi}/common/alerts`;

export async function getInvestigationData(payload) {
  const { limit, offset } = payload;
  const dataURL = baseUrl;
  const params = {
    ...payload,
    sourceIds: localStorage.getItem('isNCDNotAvailable') == '0' ? '0,1' : '0,',
    limit: limit || 20,
    offset: offset || 0
  };

  return await axios.get(dataURL, { params }).then((res) => {
    const { payload, total } = res.data;

    const formattedListOfData = payload.map((o) => {
      const {
        alertId,
        alertDate,
        primaryPartyKey,
        primaryPartyName,
        isIssue,
        alertType,
        alertSourceId,
        alertStatus,
        rules,
        alertLevel,
        alertScore,
        segmentName,
        segmentCode,
        accountId,
        accountType,
        accountOpenDate,
        hitsScore,
        alertAge,
        clusterId,
        clusterScore,
        analystName,
        closureDate,
        investigationResult,
        isStr,
        supervisorNote,
        investigatorNote,
        nextActions,
        attachmentId,
        attachmentName,
        expectedCloseDate
      } = o;

      return {
        isIssue,
        hitsScore,
        alertAge,
        clusterId,
        clusterScore,
        analystName,
        primaryPartyName,
        primaryPartyKey,
        accountId,
        accountType,
        accountOpenDate: accountOpenDate
          ? moment(accountOpenDate).format('DD/MM/YYYY')
          : null,
        closureDate:
          closureDate && alertStatus === 'Closed'
            ? moment(closureDate).format('DD/MM/YYYY')
            : null,
        alertDate: moment(alertDate).format('DD/MM/YYYY'),
        alertId,
        alertType,
        alertSourceId,
        alertLevel,
        segmentName,
        segmentCode,
        expectedCloseDate: expectedCloseDate
          ? moment(expectedCloseDate).format('DD/MM/YYYY')
          : null,
        alertScore,
        alertStatus,
        investigationResult,
        rules: rules || [],
        str: isStr,
        supervisorNote,
        investigatorNote,
        nextActions,
        attachmentId,
        attachmentName
      };
    });

    return {
      list: formattedListOfData,
      total
    };
  });
}

export async function getInvestigationDataCounts(payload) {
  const { limit, offset } = payload;
  const dataURL = `${baseUrl}/metrics`;
  const params = {
    ...payload,
    sourceIds: localStorage.getItem('isNCDNotAvailable') == '0' ? '0,1' : '0,',
    limit: limit || 20,
    offset: offset || 0
  };

  return await axios.get(dataURL, { params }).then((res) => {
    if (res.status !== 200) {
      throw new Error('Failed to fetch investigation counts');
    }

    const {
      open,
      closed,
      underInvestigation,
      assigned,
      pendingApproval,
      alertCount,
      anomalyCount
    } = res.data;
    const typeWiseCount = {
      all: alertCount + anomalyCount,
      alert: alertCount,
      anomlay: anomalyCount
    };
    const statusWiseCount = {
      open: open,
      closed: closed,
      underInvestigation: underInvestigation,
      assigned: assigned,
      pendingApproval: pendingApproval
    };

    return {
      statusWiseCount,
      typeWiseCount
    };
  });
}
